import { render, staticRenderFns } from "./study3.vue?vue&type=template&id=81474190&scoped=true&"
import script from "./study3.vue?vue&type=script&lang=js&"
export * from "./study3.vue?vue&type=script&lang=js&"
import style0 from "./study3.vue?vue&type=style&index=0&id=81474190&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81474190",
  null
  
)

export default component.exports